import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LogOut, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/AuthContext";

export const Navigation = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
    toast.success("Logged out successfully");
  };

  return (
    <nav className="bg-white border-b print:hidden" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="text-2xl font-bold text-blue-600" data-testid="nav-logo">Ellantes</Link>
            <div className="flex space-x-4">
              <Link to="/" data-testid="nav-dashboard">
                <Button variant="ghost">Dashboard</Button>
              </Link>
              <Link to="/invoices" data-testid="nav-invoices">
                <Button variant="ghost">Invoices</Button>
              </Link>
              <Link to="/estimates" data-testid="nav-estimates">
                <Button variant="ghost">Estimates</Button>
              </Link>
              <Link to="/trials" data-testid="nav-trials">
                <Button variant="ghost">Trials</Button>
              </Link>
              <Link to="/customers" data-testid="nav-customers">
                <Button variant="ghost">Customers</Button>
              </Link>
              <Link to="/products" data-testid="nav-products">
                <Button variant="ghost">Products</Button>
              </Link>
              <Link to="/settings" data-testid="nav-settings">
                <Button variant="ghost">Settings</Button>
              </Link>
            </div>
          </div>
          <div className="flex items-center">
            <Button variant="ghost" onClick={handleLogout} data-testid="logout-btn">
              <LogOut className="h-4 w-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
